// import {Link} from 'react-router-dom'
import { useEffect, useState } from "react";
import { GetClients } from "../apiconstants/constants";
import logo from "../assets/images/logo.png"
import { Link } from "react-router-dom";
import axios from "axios";
const BeforeLoginHeader = ({children}) => {
  const clientID = localStorage.getItem("clientID")
    const [clients, setClients] = useState([]);
  
  useEffect(() => {
    axios
      .get(GetClients.APIURL)
      .then((response) =>  { 
      setClients(response.data?.filter((x)=>x.guid==clientID))})
      .catch((error) => console.error("Error fetching clients", error));
  }, [clientID]);

  const logo = clients[0]?.logoURL

    return ( 
      <>
        <nav class="navbar navbar-light bg-light justify-content-between">
        <Link to="/home"> <img src={logo} height={50} alt="Logo"/>
            </Link>
      <div class="bb">
      <span class=" navbar-text">
                                  <Link to={`/Login?clientId=${clientID}`}> <button type="button" class="btn btn-primary mr-3">Login</button></Link> 
                </span>      </div>
    </nav>
    <div className="content" id="content">
           {children}
        </div>
    </>
     );
}
export default BeforeLoginHeader;